import { useCallback, useEffect, useState } from 'react';
import { fetchClubs } from '@/services/clubsService';
import type { ApiClientError, ClubsPublicResponse } from '@/types/api';

interface UseClubsState {
  data: ClubsPublicResponse | null;
  error: ApiClientError | null;
  loading: boolean;
  refresh: () => Promise<void>;
}

export function useClubs(): UseClubsState {
  const [data, setData] = useState<ClubsPublicResponse | null>(null);
  const [error, setError] = useState<ApiClientError | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    const result = await fetchClubs();

    if (result.ok) {
      setData(result.data);
      setError(null);
    } else {
      setData(null);
      setError(result.error);
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { data, error, loading, refresh };
}
